module.exports = __webpack_public_path__ + "static/media/subtract-red.1f5e7a73.svg";